import { Button } from 'antd';
import { ButtonType } from 'antd/lib/button';
import React, { useEffect } from 'react';
import './style.scss';

interface IProps {
    type?: ButtonType;
    htmlType?: 'button' | 'submit' | 'reset';
    text?: React.ReactNode;
    icon?: React.ReactNode;
    iconRight?: React.ReactNode;
    className?: string;
    color?: string;
    disabled?: boolean;
    width?: string | number;
    height?: string | number;
    isLoading?: boolean;
    onClick?: () => void;
    letterSpacing?: boolean;
    danger?: boolean;
    warning?: boolean;
    children?: React.ReactNode;
    borderRadius?: string;
    id?: string;
    onBlur?: () => void;
    onMouseDown?: (e: any) => void;
}

const ButtonWrap: React.FC<IProps> = ({
    type = 'default',
    htmlType = 'button',
    text,
    icon,
    className = '',
    color,
    disabled,
    width,
    height,
    isLoading,
    onClick,
    letterSpacing,
    danger,
    iconRight,
    children,
    borderRadius,
    id,
    onBlur,
    onMouseDown,
}) => {
    const nameRandom = `button-${Math.random()}`;

    useEffect(() => {
        const element = document.getElementsByClassName(nameRandom)[0];
        element.addEventListener(
            'mouseover',
            (event: any) => {
                document
                    .getElementsByClassName(nameRandom)[0]
                    ?.setAttribute('ant-click-animating-without-extra-node', 'true');
                setTimeout(() => {
                    document
                        .getElementsByClassName(nameRandom)[0]
                        ?.setAttribute('ant-click-animating-without-extra-node', 'false');
                }, 500);
            },
            false,
        );
    }, [nameRandom]);

    return (
        <Button
            type={type}
            danger={danger}
            className={`c-button ${className} ${type} ${nameRandom}`}
            style={{
                width: width,
                height: height,
                letterSpacing: letterSpacing ? '-2px' : 'unset',
                borderRadius: borderRadius,
            }}
            icon={icon}
            onClick={onClick}
            disabled={disabled}
            loading={isLoading}
            htmlType={htmlType}
            id={id}
            onBlur={() => {
                if (!onBlur) return;
                else onBlur();
            }}
            onMouseDown={onMouseDown}
        >
            {text}
            {iconRight}
            {children}
        </Button>
    );
};

export default React.memo(ButtonWrap);
